"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RETIVUT_QUOTE_FOLLOW_UP_BODY = exports.RETIVUT_QUOTE_TEMPLATE_BODY = exports.RETIVUT_QUOTE_FOLLOW_UP_TEMPLATE_NAME = exports.RETIVUT_QUOTE_TEMPLATE_NAME = exports.RETIVUT_QUOTE_AMOUNTS = void 0;
exports.retivutQuoteAmount = retivutQuoteAmount;
exports.retivutQuoteText = retivutQuoteText;
exports.defaultRetivutQuoteDocument = defaultRetivutQuoteDocument;
exports.RETIVUT_QUOTE_AMOUNTS = [1650, 1750, 1800, 2200, 2500];
exports.RETIVUT_QUOTE_TEMPLATE_NAME = 'retivut_quote_offer_v20261101';
exports.RETIVUT_QUOTE_FOLLOW_UP_TEMPLATE_NAME = 'commercial_followup_2d';
exports.RETIVUT_QUOTE_TEMPLATE_BODY = `שלום רב,

בהמשך לשיחתנו, אשמח להציע לך בדיקה מקצועית לאיתור מקור הבעיה (רטיבות/נזילה) בעלות של {{1}} ₪ כולל מע"מ.

מטרת הבדיקה היא לתת אבחון מקצועי, מדויק וברור, כדי להבין באופן מדויק את מקור הבעיה ולהמשיך לטיפול נכון ויעיל.

הבדיקה מתבצעת באמצעות ציוד מתקדם ובהתאם לצורך ולממצאים בשטח.

התחייבות שלנו: אם לא מצאנו את מקור הרטיבות – לא תשלם/י.

למידע נוסף:

הצעת מחיר מפורטת: {{2}}

סרטון הסבר קצר: https://youtu.be/mFw1uzfzxCk?si=h4jER6qMI7_OqDS9

המלצות בגוגל: http://www.bit.ly/Miltitan`;
exports.RETIVUT_QUOTE_FOLLOW_UP_BODY = `היי,
שלחנו לך את הצעת המחיר ורצינו רק לוודא שהיא התקבלה.
אם יש לך שאלה לגבי הבדיקה, התהליך או קביעת מועד ${String.fromCodePoint(0x2014)} אפשר לכתוב לנו כאן ונשמח לעזור.
אם הנושא כבר הסתדר או שאינו רלוונטי כרגע, נשמח לעדכון קצר.
צוות מולטיטן
073-3745778`;
function retivutQuoteAmount(stageId) {
    return exports.RETIVUT_QUOTE_AMOUNTS.find(amount => stageId === `quote_${amount}`) ?? null;
}
function retivutQuoteText(amount, documentUrl) {
    return exports.RETIVUT_QUOTE_TEMPLATE_BODY.replace('{{1}}', String(amount)).replace('{{2}}', documentUrl);
}
function defaultRetivutQuoteDocument(amount) {
    return { url: `https://tinyurl.com/rativyt${amount}ils`, version: 'owner-2026-11-01' };
}
